import React, { useEffect, useRef, useState } from "react";
import { Form, Icon, Input } from "antd";

const { Search } = Input;

const initialSearchState = { value: null, isLoading: false, isSuccess: false };
export default function AsyncTextInput({
  form,
  getFieldDecorator,
  setFields,
  callback = () => {},
  onValueChange,
  initialValue = undefined,
  labelInValue = false,
  label,
  name,
  options = [],
  allowClear,
  disabled = false,
  placeholder = "Introduzca un valor...",
  required = false,
  requiredMessage = "Debe seleccionar un valor.",
  errorMessage = "No se ha encontrado nada con ese valor.",
  pattern,
  patternMessage = "Introduzca un valor válido. ",
}) {
  const outerTimeoutRef = useRef(null);
  const clearErrorRef = useRef(null);
  const [search, setSearch] = useState(initialSearchState);

  const fetchData = async (searchValue) => {
    return callback(searchValue);
  };

  useEffect(() => {
    return () => {
      clearTimeout(outerTimeoutRef.current);
      clearTimeout(clearErrorRef.current);
    };
  }, []);

  // const handleChange = async (e) => {
  //   setSearch(initialSearchState);
  //   const { value } = e?.target;

  //   if (value.trim()) {
  //     clearTimeout(outerTimeoutRef.current);

  //     outerTimeoutRef.current = setTimeout(async () => {
  //       setSearch((prevState) => ({
  //         ...prevState,
  //         isLoading: true,
  //       }));

  //       const response = await fetchData(e.target.value);

  //       if (response && Object?.keys(response)?.length > 0) {
  //         return setSearch({
  //           value: value,
  //           isLoading: false,
  //           isSuccess: true,
  //         });
  //       }

  //       setSearch({
  //         value: null,
  //         isLoading: false,
  //         isSuccess: false,
  //       });
  //       setFields({
  //         [`${name}`]: {
  //           value: null,
  //           errors: [new Error(errorMessage)],
  //         },
  //       });
  //     }, 1000);
  //   }
  // };

  const handleChange = async (e) => {
    clearTimeout(outerTimeoutRef.current);
    clearTimeout(clearErrorRef.current);

    setSearch(initialSearchState);
    const { value } = e?.target || {};

    if (typeof onValueChange === "function") {
      onValueChange(value, name);
    }

    if (value?.trim()) {
      outerTimeoutRef.current = setTimeout(async () => {
        setSearch((prev) => ({ ...prev, isLoading: true }));
        const response = await fetchData(value);

        if (response && Object.keys(response).length > 0) {
          setSearch({ value, isLoading: false, isSuccess: true });
          return;
        }

        setSearch({ value: null, isLoading: false, isSuccess: false });

        setFields({
          [name]: {
            errors: [new Error(errorMessage)],
          },
        });

        clearErrorRef.current = setTimeout(() => {
          setFields({
            [name]: {
              errors: undefined,
            },
          });

        }, 5000);

      }, 3000);
    }
  };

  return (
    <Form.Item label={label}>
      {getFieldDecorator(name, {
        initialValue: initialValue,
        rules: [
          { required: required, message: requiredMessage },
          pattern && {
            pattern: pattern,
            message: patternMessage,
          },
        ],
      })(
        <Search
          placeholder={placeholder}
          onChange={handleChange}
          loading={search?.isLoading}
          suffix={
            search?.isSuccess ? (
              <Icon type="check" style={{ color: "#389e0d" }} />
            ) : null
          }
        />
      )}
    </Form.Item>
  );
}
